/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Content_AiInputs */

const en_directory_submit_content_ai = /** @type {(inputs: Directory_Submit_Content_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Autofill`)
};

const zh_directory_submit_content_ai = /** @type {(inputs: Directory_Submit_Content_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 自动填写`)
};

/**
* | output |
* | --- |
* | "AI Autofill" |
*
* @param {Directory_Submit_Content_AiInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_content_ai = /** @type {((inputs?: Directory_Submit_Content_AiInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Content_AiInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_content_ai(inputs)
	return zh_directory_submit_content_ai(inputs)
});
export { directory_submit_content_ai as "directory.submit.content.ai" }